export interface IEditPersonalInfosRequest {
  email: string;
  phoneCode: string;
  countryCode: string;
  phone: string;
  dateOfBirth: string;
}

export interface IEditCreatorPersonalInfosRequest {
  name: string;
  city: string;
  description: string;
  dateOfBirth: string;
}

export interface IEditCreatorChatDefaultPageRequest {
  defaultPage: string;
  chat: string;
}

export interface IBillingAddressRequest {
  companyName: string;
  address: string;
  city: string;
  postalCode: number | string;
  country: string;
  vatNumber: string;
}

export const defaultEditPersonalInfosRequest: IEditPersonalInfosRequest = {
  email: "",
  phoneCode: "",
  countryCode: "",
  phone: "",
  dateOfBirth: "",
};

export const defaultCreatorEditPersonalInfosRequest: IEditCreatorPersonalInfosRequest = {
  name: "",
  dateOfBirth: "",
  city: "",
  description: "",
};

export const defaultCreatorEditChatDefaultPageInfosRequest: IEditCreatorChatDefaultPageRequest = {
  defaultPage: "",
  chat: "",
};

export const initialBillingAddressRequest: IBillingAddressRequest = {
  companyName: "",
  address: "",
  city: "",
  postalCode: 0,
  country: "",
  vatNumber: "",
};
